import React from "react";
import styles from "./ui.module.css";

const VARIANT_MAP = {
  action: styles.buttonAction,
  form: styles.buttonForm,
  danger: styles.buttonDanger,
  refresh: styles.buttonRefresh,
};

/**
 * Shared button primitive with variant support.
 *
 * Variants:
 *  - "action" (default): secondary color, for table action bars (New, Edit, Copy, Filter, PDFs)
 *  - "form": primary color, for form-level actions (Save, Submit, Approve, Back)
 *  - "danger": delete color, for destructive actions (Reject)
 *  - "refresh": like action but with gap for icon placement
 *
 * Props:
 *  - variant: "action" | "form" | "danger" | "refresh"
 *  - desktopOnly: boolean — hidden below 1024px
 *  - className: string — additional classes
 *  - All standard button props (onClick, disabled, title, children, etc.)
 */
export const Button = ({
  variant = "action",
  desktopOnly = false,
  className = "",
  children,
  ...rest
}) => {
  const variantClass = VARIANT_MAP[variant] || VARIANT_MAP.action;
  const desktopClass = desktopOnly ? styles.desktopOnly : "";

  return (
    <button
      className={`${variantClass} ${desktopClass} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
};
